import { useSelector } from 'react-redux';
import { PageState } from 'models/PageState';
import {
  getProductShortDescription,
  getProductDescription,
  getAttributes,
  getTotalNumberOfReviews
} from 'views/ProductPage/selector';
import { ReactComponent } from 'models/ReactComponent';
import { AccordionContainer, AccordionSection } from 'components/Accordion';
import { ProductDescription } from './sections/productDescription';
import {
  getHasAttributes,
  getHasDescription,
  getHasShortDescription,
  getHasFaq
} from './validators';
import { ProductReviews } from 'views/ProductPage/reviews/themes/BGH';
import { rm, withCurrentPage } from 'utils';
import { ProductShortDescription } from './sections/productShortDescription';
import { StandaloneProductAttributes } from './sections/productAttributes';
import { MobilePackageProduct } from './sections/packageProduct';
import { MobileReviewStats } from 'views/ProductPage/reviews/themes/BGH/reviewStats';
import { ProductFaqs } from 'views/ProductPage/faqs/themes/BGH';
import { getFaqs } from 'views/ProductPage/faqs/themes/BGH/selector';
import { getCartItems } from 'components/Cart/selector';
import { isMobile } from 'components/Shared/responsive';
import styles from './productAccordion.scss';

export const ProductAccordion = () => {
  const faqs = useSelector(getFaqs);
  const shortDescription = useSelector<PageState, ReactComponent>(state =>
    getProductShortDescription(state.currentPage)
  );
  const description = useSelector<PageState, ReactComponent | undefined>(getProductDescription);
  const attributes = useSelector(withCurrentPage(getAttributes));

  const cartItems = useSelector(getCartItems);
  const mobile = useSelector(isMobile);
  const useScrollMargin = mobile && cartItems.length > 0;

  const numberOfReviews = useSelector(getTotalNumberOfReviews);
  const hasReviews = numberOfReviews > 0;
  const hasShortDescription = getHasShortDescription({ shortDescription });
  const hasDescription = getHasDescription({ description });
  const hasAttributes = getHasAttributes({ attributes });
  const hasFaq = getHasFaq({ faqs });

  return (
    <AccordionContainer>
      <MobilePackageProduct />
      {hasShortDescription && (
        <div className={styles.shortWrapper}>
          <ProductShortDescription />
        </div>
      )}
      <AccordionSection
        sectionHeaderClassName={styles.sectionHeader}
        hide={!hasDescription && !hasShortDescription}
        title={rm('product_description_header')}
      >
        <ProductShortDescription hideAttributes hideBrand />
        <ProductDescription />
      </AccordionSection>
      <AccordionSection
        sectionHeaderClassName={styles.sectionHeader}
        hide={!hasAttributes}
        title={rm('product_description_attributes')}
      >
        <StandaloneProductAttributes hideTitle />
      </AccordionSection>
      <AccordionSection
        sectionHeaderClassName={styles.sectionHeader}
        id="productReviews"
        useScrollMargin={useScrollMargin}
        right={<MobileReviewStats />}
        hide={!hasReviews}
        title={rm('product_review_section_header')}
        isReview
      >
        <ProductReviews />
      </AccordionSection>
      <AccordionSection
        sectionHeaderClassName={styles.sectionHeader}
        hide={!hasFaq}
        title={rm('product_faq_header')}
      >
        <ProductFaqs tabletSize="1" phoneSize="1" />
      </AccordionSection>
    </AccordionContainer>
  );
};
